import React from "react";
import BannerCard from "@/components/ui/banner-card";
import KeyFacts from "@/components/pages/country/key-facts";
import {
  keyFacts,
  climateImpacts,
  stories,
  partners,
  seo,
  jsonLd,
} from "@/data/india";
import ClimateImpacts from "@/components/pages/country/climate-impacts";
import Stories from "@/components/pages/country/stories";
import Partners from "@/components/pages/country/partners";
import States from "@/components/pages/country/states";
import Section from "@/components/ui/section";
import Head from "next/head";
import Seo from "@/utils/seo";
export default function India() {
  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <BannerCard
        banner={{
          title: "India",
          image: "/images/india/india banner 166X400 V2.webp",
        }}
        isActive={true}
        variant="single"
        description="PCI operates three initiatives in India: Migrants Resilience
          Collaborative, Grassroots Resilience Institute and the Climate Resilience Initiative."
      />
      <KeyFacts data={keyFacts} />
      <ClimateImpacts data={climateImpacts} columns={3} />
      <Stories
        data={stories}
        title="Stories of climate-affected internal migrants from India"
      />
      {/* <Partners data={partners} /> */}
      <States
        map="/images/India.webp"
        title="Geographical Presence of PCI"
        className="lg:-mt-12 -mt-8"
      />
      {/* <Section variant="flatZero" className="mb-16">
        <p className="text-center text-darkBlue">
          For more on internal migration in Asia and Southeast Asia, read our
          report{" "}
          <a
            href="#"
            target="_blank"
            rel="noreferrer"
            className="text-darkBlue underline hover:text-lightBlue transition-all duration-300 ease"
          >
            Internal Migration in Asia
          </a>
        </p>
      </Section> */}
    </>
  );
}
